// extracted by mini-css-extract-plugin
export default {"slider":"ForcedChoiceToolbar_slider__vDuo5","thumb":"ForcedChoiceToolbar_thumb__QizpZ","track":"ForcedChoiceToolbar_track__vB7Dr","rail":"ForcedChoiceToolbar_rail__wJiI+"};